import { IDecimalRoundBehavior } from "./IDecimalRoundBehavior";

export interface IDecimalRoundBehaviorSpecifiable {
  decimalRoundBehavior: IDecimalRoundBehavior;
}

export function instanceOfIDecimalRoundBehaviorSpecifiable(instance: any): instance is IDecimalRoundBehaviorSpecifiable {
  return instance
      && (instance.decimalRoundBehavior !== undefined);
}
